'use client';

import { Swiper, SwiperSlide } from 'swiper/react';

import { AppImageData } from '@/shared/components/appImage';
import { MainContainer } from '@/shared/components/mainContainer';
import { SmallCard } from '@/shared/components/smallCard';
import { useGetClientHost } from '@/shared/hooks';
import { classNames } from '@/shared/lib/classNames/classNames';
import { isKzDomain } from '@/shared/utils/getDomainInfo';

interface AdvantagesProps {
  list: {
    /** Legacy signed URL — для новых страниц используйте imageData. */
    imageSrc?: string;
    imageData?: AppImageData;
    description: string;
    subDescription?: string;
    href?: string;
    alt: string;
  }[];
  /** Вариант списка для KZ-домена, домен определяется на клиенте. */
  kzDomainList?: AdvantagesProps['list'];
  customClassNames?: {
    card: {
      className?: string;
      content: string;
      subDescription: string;
    };
  };
}

/**
 * @deprecated
 * используй компонент из shared/advantages
 */
const Advantages: React.FC<AdvantagesProps> = ({
  list: defaultList,
  kzDomainList,
  customClassNames,
}) => {
  const clientHost = useGetClientHost();
  const list =
    kzDomainList && isKzDomain(clientHost) ? kzDomainList : defaultList;

  return (
    <section className="mb-28 max-sm:mb-16">
      <MainContainer>
        <div className="hidden grid-cols-1 gap-6 sm:grid sm:grid-cols-2 sm:gap-8 lg:grid-cols-4">
          {list.map(
            (
              { imageSrc, imageData, description, href, alt, subDescription },
              index,
            ) => (
              <SmallCard
                descriptionId={description}
                key={index}
                imageSrc={imageSrc}
                imageData={imageData}
                description={description}
                subDescription={subDescription}
                href={href}
                alt={alt}
                customClassNames={{
                  ...customClassNames?.card,
                  main: classNames({
                    cls: 'w-full',
                    additional: [customClassNames?.card.className],
                  }),
                }}
                isAnimateLinkIcon
              />
            ),
          )}
        </div>
      </MainContainer>
      <div className="block w-full sm:hidden">
        <Swiper spaceBetween={12} slidesPerView="auto" className="!px-8 !py-2">
          {list.map(
            (
              { imageSrc, imageData, description, href, alt, subDescription },
              index,
            ) => (
              <SwiperSlide>
                <SmallCard
                  key={index}
                  alt={alt}
                  href={href}
                  description={description}
                  descriptionId={description}
                  subDescriptionId={subDescription}
                  subDescription={subDescription}
                  imageSrc={imageSrc}
                  imageData={imageData}
                  customClassNames={{
                    ...customClassNames?.card,
                    main: classNames({
                      cls: 'w-full',
                      additional: [customClassNames?.card.className],
                    }),
                  }}
                />
              </SwiperSlide>
            ),
          )}
        </Swiper>
      </div>
    </section>
  );
};

export default Advantages;
